<template>
  <div class="bottom_btn_container bgwhite1" :class="{ disabled, fixed, cancel }">
    <div class="submit-bar__bar">
      <div class="app-submit-bar-text app-dis-vcenter-row">
        <div>共1项， 总计：</div>
        <div class="app-money app-submit-bar-price">
          <span class="app-money-symbol">¥</span><span class="fontWB"> {{ price }}</span>
        </div>
      </div>
      <div class="submit-bar__button" @click="onClick">
        <span class="button__text">立即支付</span>
      </div>
    </div>

    <!-- <div class="btn">{{ title }}</div> -->
  </div>
</template>

<script>
export default {
  name: 'bottom-btn',
  props: {
    price: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
    fixed: { type: Boolean, default: false },
    cancel: { type: Boolean, default: false }
  },
  created () {
  },
  methods: {
    onClick() {
      this.$emit('confirm')
    }
  }
}
</script>

<style scoped lang="scss">
.bottom_btn_container {
  position: relative;
  border-top: 1px solid #ebebeb;
  .fontWB {
    font-weight: bold;
  }
  .submit-bar__bar {
    height: auto;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 100px;
    font-size: 28px;
    .app-submit-bar-text {
      font-size: 32px;
      margin-right: 30px;
      .app-submit-bar-price {
        color: #FC1F39;
      }
    }
    .app-dis-vcenter-row {
      display: flex;
      align-items: center;
    }
  }
  .submit-bar__button{
    background-color: #f5222d;
    border-color: #f5222d;
    color: #fff;
    width: 250px;
    font-size: 34px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    &:before {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 100%;
      height: 100%;
      background-color: #000;
      border: inherit;
      border-color: #000;
      border-radius: inherit;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      opacity: 0;
      content: ' ';
    }
  }

  &.fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  &.cancel {
    .btn {
      background-color: #fff;
      color: #323233;
      border: 1PX solid #ebedf0;
    }
  }
  &.disabled {
    .btn {
      background-color: #f89ba0;
      color: #f8f8f8;
    }
  }
}
</style>
